// src/components/modules/entertainment.js

import React, { useState } from 'react';

const Entertainment = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleVisibility = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div class={isExpanded ? 'container-expanded' : 'container'}>
      <button className={isExpanded ? 'expand-btn expanded' : 'expand-btn'} onClick={toggleVisibility}>
        {isExpanded ? 'Entertainment' : 'Entertainment'}
      </button>
      {isExpanded && (
        <ul>
          <li><a translate="no" href="https://www.youtube.com" target="_blank" rel="noopener noreferrer">YouTube</a></li>
          <li><a translate="no" href="https://www.netflix.com" target="_blank" rel="noopener noreferrer">Netflix</a></li>
          <li><a translate="no" href="https://www.spotify.com" target="_blank" rel="noopener noreferrer">Spotify</a></li>
          <li><a translate="no" href="https://www.imdb.com" target="_blank" rel="noopener noreferrer">IMDB</a></li>
          <li><a translate="no" href="https://www.ign.com" target="_blank" rel="noopener noreferrer">IGN</a></li>
          <li><a translate="no" href="https://www.vulture.com" target="_blank" rel="noopener noreferrer">Vulture</a></li>
          <li><a translate="no" href="https://www.reddit.com" target="_blank" rel="noopener noreferrer">Reddit</a></li>
        </ul>
      )}
    </div>
  );
}

export default Entertainment;